import type { BrushDefinition } from "./brushTypes";

export const crayonBrush: BrushDefinition = {
  tool: "crayon",
  label: "Crayon",
  widthMultiplier: 1.2,
  baseOpacity: 0.82,
  interpolationSpacing: 0.2,
  pressureSensitive: true,
  texture: "crayon",
};
